<style scoped="scoped" lang="scss">
.header {
  color: #303133;
  font-weight: 700;
  font-size: 18px;
}

.container {
  margin-top: 33px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  display: flex;

  .middle {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    //border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    // height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 120px;
  }
}

// 检验
.check {
  // 结论
  .check__header {
    margin-top: 16px;
    height: 22px;
    width: 100%;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    color: #303133;
  }

  // 内容
  .check__content {
    width: 100%;
    margin-top: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    // 内容项
    .check__content__item {
      width: 100%;
      margin-bottom: 30px;

      .title {
        width: 100%;
        height: 22px;
        color: #303133;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        margin-bottom: 22px;
      }

      .flag-num {
        display: grid;
        grid-template-columns: 25% 50% 15% 10%;

        .info {
          font-size: 14px;
          color: #303133;

          .info__title {
            margin-bottom: 12px;
          }
        }

        .input {
          display: flex;
          flex-wrap: wrap;
          padding-left: 12px;

          .input__item {
            margin-right: 12px;
            margin-bottom: 12px;

            .input__item__title {
              margin-bottom: 10px;
            }
          }
        }

        .result {
          .result__title {
            margin-bottom: 12px;
          }
        }
      }

      .flag-fix {
        display: grid;
        grid-template-columns: 25% 50% 15% 10%;

        .radio {
          padding-left: 12px;
        }

        .result {
          .result__title {
            margin-bottom: 12px;
          }
        }
      }

      .line {
        width: 100%;
        height: 1px;
        background: #e4e7ed;
        margin-top: 30px;
      }
    }
  }
}

.success {
  color: #67c23a;
}

.error {
  color: #f56c6c;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/quality/inspection/record/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jianyandanhao')">
            <el-input v-model="yt.conditions.inspectionNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" rexiauired>
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('jianyanzhuangtai')">
            <yi_dictionary_select type="QUALITY_INSPECTION_STATUS" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shenhezhuangtai')">
            <yi_dictionary_select type="QUALITY_INSPECTION_CHECK_STATUS" :ids.sync="yt.conditions.checkStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shijijianyanshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.actualTimeStart" :end.sync="yt.conditions.actualTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc', inspectionTypes: '1,3', checkStatus: '0' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            setDefaultValue();
            getInspectionList();
          "
          type="primary"
          v-if="utils.checkPower('web_quality_management_inspection_record_create')"
        >
          {{ $t('xinzeng') }}
        </el-button>
        <el-button
          size="mini"
          @click="deleteSelectedRecords"
          type="danger"
          :loading="deleteLoading"
          v-if="utils.checkPower('web_quality_management_record_first_batch_delete')"
          :disabled ="selectedIds.length <= 0">
          {{ $t('shanchu') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status == 1">
            <el-popconfirm title="是否作废单据?" confirm-button-text="是" cancelButtonText="否" @confirm="toVoid(scope.row)" v-if="utils.checkPower('web_quality_management_record_first_invalid_button')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '首末检验-作废' } }">
              <el-button type="text" slot="reference">{{ $t('zuofei') }}</el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1">
            <el-button
              v-if="scope.row.status == 1 && utils.checkPower('web_quality_management_inspection_record_saveRecord')"
              type="text"
              @click="
                yt.showEditDialog('jianyan', scope.row, '1000px');
                getInspection();
              "
              >{{ $t('jianyan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.status == 2 || scope.row.status == 3 || scope.row.status == 4" type="text" @click="yt.showEditDialog('chakan', scope.row, '80%')">{{ $t('chakan') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="scope.row.specBookLoading" @click="getLatestFileId(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '首末检验-查看规格书' } }">
              {{ $t('guigeshu') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="scope.row.workInstrLoading" @click="getTask(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '首末检验-查看作业指导书' } }">
              {{ $t('zuoyezhidaoshu') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_quality_management_inspection_record_figure')" type="text" :loading="scope.row.figureLoading" @click="getFigure(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '首末检验-查看图档' } }">
              {{ $t('tudang') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.wo && scope.row.wo.status == 3 && scope.row.inspectionType == 1 && utils.checkPower('web_quality_management_inspection_record_bind_wo_page')" type="text" @click="yt.showEditDialog('bangdingshengchangongdan', scope.row, '80%')">
              {{ $t('bangdingshengchangongdan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="scope.row.checkReportLoading" v-if="scope.row.status == 2 || scope.row.status == 3" type="text" @click="getFileDownload(scope.row)">
              {{ $t('jianyanbaogao') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="scope.row.reviewLoading" v-if="scope.row.inspectionType == 1 && scope.row.checkStatus == '0' && enableStatus && utils.checkPower('web_quality_management_record_first_check')" type="text" @click="review(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '首末检验-审核' } }">
              {{ $t('shenhe') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="scope.row.deReviewLoading" v-if="scope.row.inspectionType == 1 && scope.row.checkStatus == '1' && enableStatus && utils.checkPower('web_quality_management_record_first_unapprove')" type="text" @click="deReview(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '首末检验-反审核' } }">
              {{ $t('fanshenhe') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="(scope.row.status == 2 || scope.row.status == 3) && utils.checkPower('web_quality_management_record_first_judgement_modify_stlt')" type="text" @click="judgementModify(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '首末检验-改判' } }">
              {{ $t('gaipan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="(scope.row.status == 2 || scope.row.status == 3) && utils.checkPower('web_quality_management_record_first_copy_record')" type="text" @click="copyRecord(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '首末检验-复制检验单' } }">
              {{ $t('fuzhijianyandan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('jianyanleixing')" required>
            <el-select v-model="yt.editObj.inspectionType" @change="inspectionTypeChange">
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jianyanfangshi')" required>
            <el-select :max="1" filterable :clearable="true" v-model="yt.editObj.inspectionMethodId">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shengchangongdanhao')" required>
            <yi_cross_select :max="1" :component="'web_quality_management_work_order'" :ids.sync="yt.editObj.woId" @getItems="getItem"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('gongxumiaoshu')" required>
            <el-input disabled v-model="procedureDesc"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
            <el-input disabled v-model="materialId" suffix-icon="el-icon-arrow-down"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanbiaozhunmingcheng/banben')" required>
            <el-select :disabled="disabled" filterable :clearable="true" v-model="inspectionStandardId" @change="selectChange">
              <el-option v-for="(item, index) in standardList" :key="index" :label="item.testName" :value="item.testId"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jihuajianyanshijian')" required>
            <yi_time_input :format="'yyyy-MM-dd HH:mm'" type="datetime" :time.sync="yt.editObj.planTime"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('songjianshuliang')" required>
            <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" @input="qualityInput()" v-model="yt.editObj.submitInspectionNum" size="mini"> </el-input>
          </el-form-item>
          <el-form-item v-if="yt.editObj.inspectionType == 1" :label="$t('shijimaozhongke')">
            <el-input type="number" oninput="if(value.indexOf('.') > 0){value=value.slice(0,value.indexOf('.') + 4)}" v-model="yt.editObj.actualGrossWeight" size="mini"> </el-input>
          </el-form-item>
          <el-form-item v-if="yt.editObj.inspectionType == 1" :label="$t('shijijingzhongke')">
            <el-input type="number" oninput="if(value.indexOf('.') > 0){value=value.slice(0,value.indexOf('.') + 4)}" v-model="yt.editObj.actualNetWeight" size="mini"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel()">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/quality/inspection/record/create', beforeReq);inspectionStandardId = null;standardList = [];" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '首末检验-新增首末检验' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 检验 -->
      <template v-if="yt.editObj.action === 'jianyan'">
        <div class="dialog-scroller check">
          <div class="check__header">{{ $t('jianyanjielun') }}:{{ defaultResult == 0 ? $t('jianyanbuhege') : $t('jianyanhege') }}</div>
          <div class="check__content">
            <!--每一项-->
            <div class="check__content__item" v-for="(item, index) in category" :key="index">
              <div class="title">
                {{ item.name }}
              </div>
              <!--定量-->
              <div v-for="(value, flagNumIndex) in item.flag_num" :key="value.id" class="flag-num">
                <div class="info">
                  <div class="info__title">
                    {{ value.item }}:
                    {{ getMiddleValue(value.specMax, value.specMin) }}
                  </div>
                  <div class="info__num">{{ $t('guigeshangxian') }}: {{ value.specMax }}; {{ $t('guigexiaxian') }}: {{ value.specMin }}</div>
                </div>
                <div class="input">
                  <div v-for="(inputItem, inputIndex) in value.inputList" :key="inputIndex" class="input__item">
                    <div class="input__item__title">
                      <span style="color: #F56C6C">*</span>
                      <span>{{ $t('yangben') }}{{ inputIndex + 1 }}</span>
                    </div>
                    <div class="input__input">
                      <el-input-number size="mini" v-model="inputItem.value" :controls="false" :precision="5" style="width: 88px;" @change="v => changeFlagNum(v, value)" />
                    </div>
                  </div>
                </div>
                <div class="upload">
                  <div style="margin-bottom: 12px">{{ $t('shangchuantupian') }}</div>
                  <div>
                    <yi_upload :accept="'image/png, image/jpeg'" :ids.sync="value.imgInfoIds" :limit="5">
                      <div slot="limitMsg"></div>
                    </yi_upload>
                  </div>
                </div>
                <div class="result">
                  <div class="result__title">{{ $t('jianyanjieguo') }}</div>
                  <div v-if="value.result == 1" class="result__info success">{{ $t('hege') }}</div>
                  <div v-if="value.result == 0" class="result__info error">{{ $t('buhege') }}</div>
                </div>
              </div>
              <!--定性-->
              <div v-for="(value, flagFixIndex) in item.flag_fix" :key="value.id" class="flag-fix">
                <div class="info">
                  <div class="info__title">{{ value.item }}</div>
                  <div class="info__num">{{ $t('guigeshangxian') }}: {{ value.specMax }}; {{ $t('guigexiaxian') }}: {{ value.specMin }}</div>
                </div>
                <div class="radio">
                  <span>{{ $t('dingxingjianyan') }}:</span>
                  <span style="margin-left: 24px">
                    <el-radio v-model="value.result" label="1">{{ $t('hege') }}</el-radio>
                    <el-radio v-model="value.result" label="0">{{ $t('buhege') }}</el-radio>
                  </span>
                </div>
                <div class="upload">
                  <div style="margin-bottom: 12px">{{ $t('shangchuantupian') }}</div>
                  <div>
                    <yi_upload :accept="'image/png, image/jpeg'" :ids.sync="value.imgInfoIds" :limit="5">
                      <div slot="limitMsg"></div>
                    </yi_upload>
                  </div>
                </div>
                <div class="result" ref="myComponent">
                  <div class="result__title">{{ $t('jianyanjieguo') }}</div>
                  <div v-if="value.result == 1" class="result__info success">{{ $t('hege') }}</div>
                  <div v-if="value.result == 0" class="result__info error">{{ $t('buhege') }}</div>
                </div>
              </div>
              <div style="margin-top:5px">
                <span style="padding-right:5px">{{ $t('beizhu') }}:</span><el-input size="mini" v-model="item.remark" style="width: 150px;" />
              </div>
              <div class="line"></div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="verifySaveLoading" @click="submitSample" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '首末检验-检验' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action === 'chakan'">
        <div class="dialog-scroller">
          <record_details :detailsItem="yt.editObj"></record_details>
        </div>
      </template>
      <template v-if="yt.editObj.action === 'bangdingshengchangongdan'">
        <div class="dialog-scroller">
          <bind_wo :detailsItem="yt.editObj"></bind_wo>
        </div>
      </template>
      <template v-if="yt.editObj.action === 'guigeshu'">
        <div class="dialog-scroller">
          <el-table :data="fileList" border style="width: 100%">
            <el-table-column prop="fileInfo.name" :label="$t('wenjianmingcheng')" width="180"></el-table-column>
            <el-table-column prop="createByObject.nickname" :label="$t('chuangjianren')" width="180"></el-table-column>
            <el-table-column prop="createTime" :label="$t('chuangjianshijian')">
              <template slot-scope="scope">
                {{ scope.row.createTime != null ? dayjs.unix(scope.row.createTime / 1000).format('YYYY-MM-DD HH:mm:ss') : '' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('caozuo')">
              <template slot-scope="scope">
                <el-button type="text" :loading="scope.row.lookLoading" @click="setFileId(scope.row)">{{ $t('chakan') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 100, 500]" :page-size="10" layout="sizes, prev, pager, next" :total="total"> </el-pagination>
          </div>
        </div>
      </template>
      <template v-if="yt.editObj.action === 'zuoyezhidaoshu'">
        <div class="dialog-scroller">
          <el-table :data="fileList" border style="width: 100%">
            <el-table-column prop="fileInfo.name" :label="$t('wenjianmingcheng')" width="180"></el-table-column>
            <el-table-column prop="createByObject.nickname" :label="$t('chuangjianren')" width="180"></el-table-column>
            <el-table-column prop="createTime" :label="$t('chuangjianshijian')">
              <template slot-scope="scope">
                {{ scope.row.createTime != null ? dayjs.unix(scope.row.createTime / 1000).format('YYYY-MM-DD HH:mm:ss') : '' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('caozuo')">
              <template slot-scope="scope">
                <el-button type="text" :loading="scope.row.lookLoading" @click="setFileId(scope.row)">{{ $t('chakan') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 100, 500]" :page-size="10" layout="sizes, prev, pager, next" :total="total"> </el-pagination>
          </div>
        </div>
      </template>
      <template v-if="yt.editObj.action === 'tudang'">
        <div class="dialog-scroller">
          <el-table :data="fileList" border style="width: 100%">
            <el-table-column prop="fileInfo.name" :label="$t('wenjianmingcheng')" width="180"></el-table-column>
            <el-table-column prop="createByObject.nickname" :label="$t('chuangjianren')" width="180"></el-table-column>
            <el-table-column prop="createTime" :label="$t('chuangjianshijian')">
              <template slot-scope="scope">
                {{ scope.row.createTime != null ? dayjs.unix(scope.row.createTime / 1000).format('YYYY-MM-DD HH:mm:ss') : '' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('caozuo')">
              <template slot-scope="scope">
                <el-button type="text" :loading="scope.row.lookLoading" @click="setFileId(scope.row)">{{ $t('chakan') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 100, 500]" :page-size="10" layout="sizes, prev, pager, next" :total="total"> </el-pagination>
          </div>
        </div>
      </template>
      <template v-if="yt.editObj.action === 'yulan'">
        <preview :url="previewUrl"></preview>
      </template>
      <!-- 改判 -->
      <template v-if="yt.editObj.action === 'gaipan'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gaipanjieguo')" required>
            <yi_dictionary_select type="QUALITY_INSPECTION_STATUS" :disabled="true" :ids.sync="yt.editObj.modifyResult"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('gaipanyuanyin')">
            <el-input type="textarea" v-model="yt.editObj.reason"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel()">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/judgement/modification/record/judgementModify')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import record_details from '@@/pages/web/quality_management/record_first/record_details';
import bind_wo from '@@/pages/web/quality_management/record_first/bind_wo';
import preview from '@@/pages/other/utils/preview';
export default {
  name: 'web_quality_management_record_first_list',
  components: {
    record_details,
    bind_wo,
    preview
  },
  data() {
    return {
      inspectionStandardId: '',
      enableStatus: false,
      verifySaveLoading: false,
      editObject: {},
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      typeList: [],
      disabled: true,
      category: {},
      sums: '',
      fildIds: '',
      resultValue: '',
      defaultResult: '',
      imgInfoIds: [],
      procedureDesc: '',
      materialId: '',
      workOrder: '',
      materialIds: '',
      show: false,
      standardList: [],
      inspectionList: [],
      fileList: [],
      fileListWindowShow: false,
      items: '', //检验项目
      colorNoEnable: false,
      selectedIds: [], // 存储选中的记录ID
      deleteLoading: false, // 删除操作加载状态
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'jianyandanhao',
          prop: 'inspectionNo',
          width: 150
        },
        {
          label: 'shengchangongdanhao',
          prop: 'wo.no',
          width: 130
        },
        {
          label: 'gongxumiaoshu',
          prop: 'woProcedure.procedureDesc',
          width: 130
        },
        {
          label: 'jianyanleixing',
          prop: 'inspectionType',
          type: 'dictionary',
          key: 'QUALITY_INSPECTION_TYPE',
          width: 130
        },
        {
          label: 'jianyanfangshi',
          prop: 'inspectionMethod.name',
          width: 130
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 130
        },
        {
          label: 'sehao',
          prop: 'plan.colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 130,
          show: false
        },
        {
          label: 'shijimaozhongke',
          prop: 'actualGrossWeight',
          width: 130
        },
        {
          label: 'shijijingzhongke',
          prop: 'actualNetWeight',
          width: 130
        },
        {
          label: 'jianyanbiaozhunmingcheng',
          prop: 'inspectionStandardName',
          width: 130
        },
        {
          label: 'jianyanbiaozhunbanben',
          prop: 'version',
          width: 130
        },
        {
          label: 'songjianshuliang',
          prop: 'submitInspectionNum',
          width: 130
        },
        {
          label: 'jihuajianyanshuliang',
          prop: 'planNum',
          width: 130
        },
        {
          label: 'jihuajianyanshijian',
          prop: 'planTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm',
          width: 130
        },
        {
          label: 'shijijianyanshijian',
          prop: 'actualTime',
          type: 'time',
          width: 130
        },
        {
          label: 'jianyanyuan',
          prop: 'inspector.nickname',
          width: 130
        },
        {
          label: 'jianyanzhuangtai',
          prop: 'status',
          type: 'tag',
          width: 130,
          tags: {
            '1': {
              color: '#E6A23C',
              text: this.$t('weijianyan')
            },
            '2': {
              color: '#67C23A',
              text: this.$t('jianyanhege')
            },
            '3': {
              color: '#F56C6C',
              text: this.$t('jianyanbuhege')
            },
            '4': {
              color: '#909399',
              text: this.$t('zuofei')
            }
          }
        },
        {
          label: 'shenhezhuangtai',
          prop: 'checkStatus',
          type: 'tag',
          width: 130,
          tags: {
            '0': {
              color: '#ff8959',
              text: this.$t('daishenhe')
            },
            '1': {
              color: '#9254de',
              text: this.$t('yishenhe')
            }
          }
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 350,
          fixed: 'right'
        }
      ],
      previewUrl: ''
    };
  },
  watch: {
    materialIds: {
      handler(n, o) {
        if (n) {
          this.getStandard();
          this.yt.get(1);
        }
      },
      immediate: false,
      deep: true
    },
    'yt.editObj.woId': {
      handler(n, o) {
        if (n) {
          this.disabled = false;
        }
      },
      immediate: false,
      deep: true
    },
    category: {
      handler(n) {
        let result = 1;
        for (let i = 0; i < n.length; i++) {
          if (n[i]['flag_num'].length > 0) {
            for (let j = 0; j < n[i]['flag_num'].length; j++) {
              if (n[i]['flag_num'][j]['result'] == 0) {
                result = 0;
              }
            }
          }
          if (n[i]['flag_fix'].length > 0) {
            for (let j = 0; j < n[i]['flag_fix'].length; j++) {
              if (n[i]['flag_fix'][j]['result'] == 0) {
                result = 0;
              }
            }
          }
        }
        this.defaultResult = result;
      },
      immediate: false,
      deep: true
    },

  },
  destroyed() {
    this.utils.event_hub.$off('INSPECTION_RECORD_BIND_WO_WORK_ORDER_CLOSE');
    clearInterval(this.timmer);
    clearInterval(this.interval);
  },
  created() {
    this.getEnableStatus();
    this.getProductionConfig();
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc',
        inspectionTypes: '1,3',
        checkStatus: '0'
      };
      this.yt.SELECT_URL = '/web/quality/sampling/procedure/listByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';
      this.yt.get(1);
      this.utils.event_hub.$on('INSPECTION_RECORD_BIND_WO_WORK_ORDER_CLOSE', () => {
        this.yt.isShowEditDialog = false;
      });
    }, 300);
  },
  methods: {
    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
        if (this.colorNoEnable) {
          this.showColumn('sehao');
        }
      });
    },
    // 显示指定列
    showColumn(label) {
      for (let i = 0; i < this.columns.length; i++) {
        const c = this.columns[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    // 审核
    review(row) {
      this.$set(row, 'reviewLoading', true);
      this.http
        .post('/web/quality/inspection/record/check', row)
        .then(res => {
          this.yt.get(1);
          this.$message.success(this.$t('caozuochenggong'));
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.$set(row, 'reviewLoading', false);
        });
    },
    // 反审核
    deReview(row) {
      this.$set(row, 'deReviewLoading', true);
      this.http
        .post('/web/quality/inspection/record/unapprove', row)
        .then(res => {
          this.yt.get(1);
          this.$message.success(this.$t('caozuochenggong'));
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.$set(row, 'deReviewLoading', false);
        });
    },
    // 系统管理-生产配置【首检单审核流程】启用状态
    getEnableStatus() {
      this.http
        .get('/web/production/config/list?type=5')
        .then(res => {
          if (res.data && res.data.length === 1 && res.data[0].status) {
            this.enableStatus = true;
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      if (this.yt.editObj.action == 'guigeshu') {
        this.getLatestFileId(this.editObject);
      }
      if (this.yt.editObj.action == 'zuoyezhidaoshu') {
        this.getTask(this.editObject);
      }
      if (this.yt.editObj.action == 'tudang') {
        this.getFigure(this.editObject);
      }
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      if (this.yt.editObj.action == 'guigeshu') {
        this.getLatestFileId(this.editObject);
      }

      if (this.yt.editObj.action == 'zuoyezhidaoshu') {
        this.getTask(this.editObject);
      }
      if (this.yt.editObj.action == 'tudang') {
        this.getFigure(this.editObject);
      }
    },
    setFileId(row) {
      if (row.fileInfoId) {
        this.fildIds = row.fileInfoId;
        this.getDownload(row);
      }
    },
    async getInspectionList() {
      return await this.http
        .get(
          '/web/quality/inspection/method/page?' +
            this.qs.stringify({
              pageNum: 1,
              pageSize: 100,
              inspectionType: this.yt.editObj.inspectionType
              // orderBy: 'sort',
            })
        )
        .then(response => {
          this.typeList = response.data.rows || [];
        })
        .catch(() => {});
    },
    inspectionTypeChange(value) {
      if (value && this.materialIds) {
        this.getStandard();
      }
      this.getInspectionList();
      setTimeout(() => {
        this.yt.editObj.inspectionMethodId = '';
      }, 100);
      console.log('inspectionTypeChange', value);
      this.$forceUpdate();
    },
    //规格书
    getLatestFileId(editObj) {
      this.$set(editObj, 'specBookLoading', true);
      this.editObject = editObj;
      let params = {
        docType: 2,
        inspectionType: editObj.inspectionType,
        materialId: editObj.materialId,
        basicWorkProcedureId: editObj.woProcedure.workProcedureId
      };

      return this.http
        .post('/web/quality/standard/doc/getLatestFileId?pageNum=' + this.page.pageNum + '&pageSize=' + this.page.pageSize, params)
        .then(res => {
          this.$set(editObj, 'specBookLoading', false);
          if (res.data.total == 1) {
            this.fildIds = res.data.rows[0].fileInfoId;
            this.getDownload();
          }
          if (res.data.total > 1) {
            this.fileList = res.data.rows;
            this.total = res.data.total;
            this.page.pageSize = 10;
            this.page.pageNum = 1;
            this.yt.showEditDialog('guigeshu', null, '800px');
          }
        })
        .catch(error => {
          this.$message.error(this.$t(error));
          this.$set(editObj, 'specBookLoading', false);
        });
    },
    //作业指导书
    getTask(editObj) {
      this.$set(editObj, 'workInstrLoading', true);
      this.editObject = editObj;
      let params = {
        docType: 1,
        inspectionType: editObj.inspectionType,
        materialId: editObj.materialId,
        basicWorkProcedureId: editObj.woProcedure.workProcedureId
      };
      return this.http
        .post('/web/quality/standard/doc/getLatestFileId?pageNum=' + this.page.pageNum + '&pageSize=' + this.page.pageSize, params)
        .then(res => {
          this.$set(editObj, 'workInstrLoading', false);
          if (res.data.total == 1) {
            this.fildIds = res.data.rows[0].fileInfoId;
            this.getDownload();
          }
          if (res.data.total > 1) {
            this.fileList = res.data.rows;
            this.total = res.data.total;
            this.page.pageSize = 10;
            this.page.pageNum = 1;
            this.yt.showEditDialog('zuoyezhidaoshu', null, '800px');
          }
        })
        .catch(error => {
          this.$message.error(this.$t(error));
          this.$set(editObj, 'workInstrLoading', false);
        });
    },
    getFigure(row) {
      this.$set(row, 'figureLoading', true);
      this.editObject = row;
      let params = {
        docType: 3,
        inspectionType: row.inspectionType,
        materialId: row.materialId,
        basicWorkProcedureId: row.woProcedure.workProcedureId
      };
      return this.http.post('/web/quality/standard/doc/getLatestFileId?pageNum=' + this.page.pageNum + '&pageSize=' + this.page.pageSize, params).then(res => {
        this.$set(row, 'figureLoading', false);
        if (res.data.total == 1) {
          this.fildIds = res.data.rows[0].fileInfoId;
          this.getDownload();
        }
        if (res.data.total > 1) {
          this.fileList = res.data.rows;
          this.total = res.data.total;
          this.page.pageSize = 10;
          this.page.pageNum = 1;
          this.yt.showEditDialog('tudang', null, '800px');
        }
      }).catch(error => {
        this.$message.error(this.$t(error));
        this.$set(row, 'figureLoading', false);
      });
    },
    getDownload(row) {
      if (row) {
        this.$set(row, 'lookLoading', true);
      }
      return this.http
        .get('/web/customer/files/download?id=' + this.fildIds)
        .then(res => {
          let baseUrl = res.data;
          if (row) {
            this.$set(row, 'lookLoading', false);
          }
          if (res.data) {
            let router = this.$router.resolve({
              path: '/utils/preview',
              query: { url: baseUrl }
            });
            window.open(router.href, '_blank');
          }
        })
        .catch(err => {
          if (row) {
            this.$set(row, 'lookLoading', false);
          }
        });
    },
    //作废
    toVoid(editObj) {
      let params = editObj;
      params.status = 4;
      this.http
        .post('/web/quality/inspection/record/update', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    getMiddleValue(value1, value2) {
      console.log('getMiddleValue', value1, value2);
      if (value1 && value2) {
        let middleValue = ((value1 + value2) / 2).toFixed(2);
        let toleranceValue = (middleValue - value2).toFixed(4);
        return middleValue + '±' + toleranceValue;
      }
    },
    qualityInput() {
      this.$forceUpdate();
    },
    submitOrder() {
      return this.http.post('/web/quality/inspection/record/saveRecord').then(res => {});
    },
    getItem(items) {
      this.procedureDesc = items.procedureDesc;
      this.materialId = items.material.code + '|' + items.material.name;
      this.materialIds = items.materialId;
      this.getStandard();
      this.workOrder = items.id;
    },
    setDefaultValue() {
      this.yt.editObj.inspectionType = 1;
      this.procedureDesc = [];
      this.materialId = [];
      this.standardList = [];
      this.yt.editObj.submitInspectionNum = 1;
      this.yt.editObj.inspectionStandardId = '';
    },
    beforeReq(params, url) {
      params.woProcedureId = this.workOrder;
      this.inspectionStandardId = '';
      return params;
    },
    copyRecord(row){
      this.verifySaveLoading = true;
      let params = {
        id: row.id,
      };
      this.http
        .post('/web/quality/inspection/record/copyRecord', params)
        .then(res => {
          this.verifySaveLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
          this.verifySaveLoading = false;
        });
    },
    judgementModify(row){
      if(row.status == 2 || row.status == 3){
        if(row.status == 2){
          this.$set(row,'originalStatus', '2');
          this.$set(row,'modifyResult', '3');
          this.$set(row,'inspectionRecordId',row.id);
          setTimeout(() => {
            this.yt.showEditDialog('gaipan', row, '500px');
          }, 200);
        }else if(row.status == 3){
          this.$set(row,'originalStatus', '3');
          this.$set(row,'modifyResult', '2');
          this.$set(row,'inspectionRecordId',row.id);
          setTimeout(() => {
            this.yt.showEditDialog('gaipan', row, '500px');
          }, 200);
        }
      }
    },
    getStandard() {
      this.http
        .get('/web/quality/inspection/standard/list', {
          params: {
            enabled: 1,
            materialId: this.materialIds,
            type: this.yt.editObj.inspectionType
          }
        })
        .then(res => {
          this.standardList = res.data;
          for (let i = 0; i < this.standardList.length; i++) {
            this.standardList[i].testName = this.standardList[i]['name'] + '|' + this.standardList[i]['version'];
            this.standardList[i].testId = this.standardList[i]['id'] + '_' + this.standardList[i]['dataSource'];
          }
        });
    },
    /**
     * 监听定量样本数量变化
     * @param value
     * @param item
     */
    changeFlagNum(value, item) {
      // 不合格数
      let sum = 0;
      for (let i = 0; i < item['inputList'].length; i++) {
        if (item['inputList'][i]['value'] !== undefined) {
          if (item['inputList'][i]['value'] < item.specMin) {
            sum += 1;
            continue;
          }
          if (item['inputList'][i]['value'] > item.specMax) {
            sum += 1;
            continue;
          }
        }
      }
      if (sum >= item['re']) {
        this.$set(item, 'result', '0');
      } else {
        this.$set(item, 'result', '1');
      }
    },
    /**
     * 检验
     */
    getInspection() {
      return this.http
        .get('/web/quality/inspection/record/details/page', {
          params: {
            pageNum: 1,
            pageSize: 10000,
            inspectionRecordId: this.yt.editObj.id
          }
        })
        .then(res => {
          const list = res.data.rows;
          const category = {};
          for (let i = 0; i < list.length; i++) {
            if (list[i]['inspectionStandardDetail']) {
              list[i]['inspectionStandardDetail']['id'] = list[i]['id'];
              list[i]['inspectionStandardDetail']['flag'] = list[i]['inspectionFlag'];
              list[i]['inspectionStandardDetail']['re'] = list[i]['samplingProcedureDTO'] ? list[i]['samplingProcedureDTO']['re'] : 0;
              this.$set(list[i]['inspectionStandardDetail'], 'result', '1');
              this.$set(list[i]['inspectionStandardDetail'], 'imgInfoIds', []);
              if (list[i]['samplingNum'] !== null) {
                const inputList = [];
                for (let j = 0; j < list[i]['samplingNum']; j++) {
                  inputList.push({
                    i: j,
                    value: undefined
                  });
                }

                this.$set(list[i]['inspectionStandardDetail'], 'inputList', inputList);
              }

              if (category[list[i]['inspectionStandardDetail']['category']] === undefined) {
                this.$set(category, list[i]['inspectionStandardDetail']['category'], [list[i]['inspectionStandardDetail']]);
              } else {
                category[list[i]['inspectionStandardDetail']['category']].push(list[i]['inspectionStandardDetail']);
              }
            }
          }
          const result = [];
          // 按定量和定性分类
          for (const i in category) {
            if (category[i].length > 0) {
              // 定性
              const flag_fix = category[i].filter(item => {
                return item['flag'] === 1;
              });
              // 定量
              const flag_num = category[i].filter(item => {
                return item['flag'] === 2;
              });
              result.push({
                name: i,
                flag_fix: flag_fix,
                flag_num: flag_num
              });
            }
          }
          console.log('resultresult', category);
          this.category = result;

          for (let g = 0; g < this.category.length; g++) {
            for (let j = 0; j < this.category[g]['flag_fix'].length; j++) {
              this.defaultResult = this.category[g]['flag_fix'][j]['result'];
            }
          }
        });
    },
    submitSample() {
      this.verifySaveLoading = true;
      const recordDetails = [];
      for (let i = 0; i < this.category.length; i++) {
        console.log(this.category);
        if (this.category[i]['flag_fix'].length > 0) {
          const measureJson = [];
          for (let j = 0; j < this.category[i]['flag_fix'].length; j++) {
            if (this.category[i]['flag_fix'][j]['inputList'].length > 0) {
              for (let z = 0; z < this.category[i]['flag_fix'][j]['inputList'].length; z++) {
                if (this.category[i]['flag_fix'][j]['inputList'][z]['value'] === undefined) {
                  measureJson.push(0);
                } else {
                  measureJson.push(this.category[i]['flag_fix'][j]['inputList'][z]['value']);
                }
              }
            }
            recordDetails.push({
              id: this.category[i]['flag_fix'][j]['id'],
              measureJson: measureJson,
              uploadFiles: this.category[i]['flag_fix'][j]['imgInfoIds'],
              result: this.category[i]['flag_fix'][j]['result'],
              remark: this.category[i]['remark']
            });
          }
        }
        if (this.category[i]['flag_num'].length > 0) {
          for (let j = 0; j < this.category[i]['flag_num'].length; j++) {
            const measureJson = [];
            if (this.category[i]['flag_num'][j]['inputList'].length > 0) {
              for (let z = 0; z < this.category[i]['flag_num'][j]['inputList'].length; z++) {
                if (this.category[i]['flag_num'][j]['inputList'][z]['value'] === undefined) {
                  measureJson.push(0);
                } else {
                  measureJson.push(this.category[i]['flag_num'][j]['inputList'][z]['value']);
                }
              }
            }
            recordDetails.push({
              id: this.category[i]['flag_num'][j]['id'],
              measureJson: measureJson,
              uploadFiles: this.category[i]['flag_num'][j]['imgInfoIds'],
              result: this.category[i]['flag_num'][j]['result'],
              remark: this.category[i]['remark']
            });
          }
        }
      }
      let params = {
        recordDetails,
        id: this.yt.editObj.id,
        status: this.defaultResult
      };
      this.http
        .post('/web/quality/inspection/record/saveRecord', params)
        .then(res => {
          this.verifySaveLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
          this.verifySaveLoading = false;
        });
    },

    //导出文件
    getFileDownload(editObj) {
      this.$set(editObj, 'checkReportLoading', true);
      this.http
        .post(`/web/quality/inspection/record/export`, { id: editObj.id })
        .then(res => {
          const fileId = res.data;
          if (!fileId) {
            this.utils.errorMessage(this.$t('wufaxiazaiwenjian'));
            this.$set(editObj, 'checkReportLoading', false);
            return;
          }

          return this.http
            .get('/web/customer/files/download?id=' + fileId)
            .then(fileRes => {
              let baseUrl = fileRes.data;
              this.$set(editObj, 'checkReportLoading', false);
              if (baseUrl) {
                window.open(baseUrl);
              } else {
                this.utils.errorMessage(this.$t('wenjianlianjieweikong'));
              }
            })
            .catch(error => {
              this.utils.errorMessage(error);
              this.$set(editObj, 'checkReportLoading', false);
            });
        })
        .catch(error => {
          this.utils.errorMessage(error);
          this.$set(editObj, 'checkReportLoading', false);
        });
    },
    selectChange(e) {
      this.yt.editObj.inspectionStandardId = e.split('_')[0];
      this.yt.editObj.dataSource = e.split('_')[1];
    },
    //quxiao
    cancel() {
      this.yt.isShowEditDialog = false;
      this.inspectionStandardId = '';
    },
    // 删除选中的记录
    deleteSelectedRecords() {
      if (this.selectedIds.length === 0) {
        this.$message.warning(this.$t('qingxuanzeyaoshanchudejilu'));
        return;
      }
      
      this.$confirm(this.$t('quedingshanchuxuanzhongdejilu'), this.$t('tishi'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      }).then(() => {
        this.deleteLoading = true;
        this.http.post('/web/quality/inspection/record/batchDelete', {
          ids: this.selectedIds
        }).then(res => {
          this.$message.success(this.$t('caozuochenggong'));
          this.selectedIds = [];
          this.yt.get(1);
        }).catch(err => {
          this.$message.error(this.$t(err));
        }).finally(() => {
          this.deleteLoading = false;
        });
      }).catch(() => {
        // 用户取消删除
      });
    },
    
    selectionChange(items) {
      this.selectedIds = items.map(item => {
        return item.id;
      });
    },
    

  }
};
</script>
